<div *ngIf="attachments&&attachments.length>0&&!loading"
     style="max-height: 300px; overflow-y: auto; overflow-x: hidden;
     display: flex; flex-direction: column; width: 100%; padding-bottom: 1rem">
  <div *ngFor="let item of attachments">
    <div class="item-container">
      <div class="item-line">
        <div class="item-info">
          <div class="item-checkbox">
            <mat-checkbox color="primary" [(ngModel)]="itemsSelected[item.attachmentGuid]"></mat-checkbox>
          </div>
          <div class="item-name" [matTooltip]="('CREATION_DATE' | translate) + ': ' + dateFormatting(item.createDate)" matTooltipPosition="above">
            {{item.name}}<span *ngIf="item.version"> (v{{item.version}})</span>
          </div>
          <div *ngIf="item.attachmentType" class="attachment-type">{{item.attachmentType}}</div>
        </div>
        <div class="item-actions">
          <button mat-icon-button class="action-button" matTooltip="{{'PREVIEW' | translate}}" matTooltipPosition="below"
                  [disabled]="item.isTorolt || !item.attachmentGuid"
                  (click)="preview(item.attachmentGuid)">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button
                  *ngIf="availableSignatures.length > 0 && availableSignaturesForMultipleSign.length === 1"
                  [disabled]="item.isTorolt || !item.attachmentGuid || !singleSignatureEnabled(item.attachmentGuid)"
                  class="action-button"
                  matTooltip="{{'SIGN' | translate}} ({{ availableSignaturesForMultipleSign[0].name }})"
                  matTooltipPosition="below"
                  (click)="signDoc(item.attachmentGuid, availableSignaturesForMultipleSign[0].type, availableSignaturesForMultipleSign[0].id)">
            <mat-icon>draw</mat-icon>
          </button>
          <button mat-icon-button
                  *ngIf="availableSignatures.length > 0 && availableSignaturesForMultipleSign.length > 1"
                  [disabled]="item.isTorolt || !item.attachmentGuid || !singleSignatureEnabled(item.attachmentGuid)"
                  class="action-button"
                  matTooltip="{{'SIGN' | translate}}"
                  matTooltipPosition="below"
                  [matMenuTriggerFor]="signDocMenu">
            <mat-icon>draw</mat-icon>
          </button>
          <mat-menu #signDocMenu="matMenu" xPosition="before">
            <button *ngFor="let method of availableSignatures" mat-menu-item (click)="signDoc(item.attachmentGuid, method.type, method.id)">
              <span>{{ method.name }}</span>
            </button>
          </mat-menu>
          <button mat-icon-button class="action-button" matTooltip="{{'DOWNLOAD' | translate}}" matTooltipPosition="below"
                  [disabled]="item.isTorolt || !item.attachmentGuid"
                  (click)="download(item.attachmentGuid)">
            <mat-icon>save_alt</mat-icon>
          </button>
        </div>
      </div>
      <mat-divider class="line-divider"></mat-divider>
    </div>
  </div>
</div>

<div *ngIf="isErrorInData">{{'SOMETHING_WENT_WRONG' | translate}}</div>
<div style="margin-bottom:12px" *ngIf="!isErrorInData">

  <div class="actions-wrapper">
    <div>
      <p class="upload-title">{{'FILE_UPLOAD' | translate}}</p>
      <div class="dropzone"
          [ngClass]="{ 'dragover': isDragOver }"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)">
        <input type="file" id="fileDropRef" multiple
              style="opacity: 0; position: relative; z-index: 2; width: 100%; height: 100%; top: 0; left: 0;"
              (change)="uploadingFiles($event)">
        <!--      <div style="position: relative; width: 100%; height: 100%">-->
        <!--        <input type="file" id="fileDropRef" multiple-->
        <!--               style="opacity: 100; position: relative; z-index: 2; width: 100%; height: 100%; top: 0; left: 0;"-->
        <!--               (change)="uploadingFiles($event)">-->
        <!--      </div>-->
        <p class="dropzone-text">{{'CHOOSE_A_FILE' | translate}}</p>
      </div>
    </div>
    <div style="text-align: right; max-width: 60%;">
      <p *ngIf="errorInSigning && errorInSigning.length > 0" style="color: red; font-size: 12px;">{{ errorInSigning }}</p>
      <button mat-flat-button *ngIf="groupActionsEnabled() && availableSignaturesForMultipleSign.length === 1" (click)="signDoc(null, availableSignaturesForMultipleSign[0].type, availableSignaturesForMultipleSign[0].id)">
        {{'SIGN' | translate}} ({{ availableSignaturesForMultipleSign[0].name }})
      </button>
      <button mat-flat-button *ngIf="groupActionsEnabled() && availableSignaturesForMultipleSign.length > 1" [matMenuTriggerFor]="groupActionMenu">{{'SIGN' | translate}}</button>
      <mat-menu #groupActionMenu="matMenu">
        <button mat-menu-item *ngFor="let method of availableSignaturesForMultipleSign" (click)="signDoc(null, method.type, method.id)">
          <span>{{ method.name }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div *ngFor="let file of uploadList.files; let i = index" class="uploaded-file-div">
    <div class="uploaded-file-inner-div">
      <div class="uploaded-file-name"
           [ngClass]="{'error-color': file.content.size > MAX_FILE_SIZE}">
        {{file.content.name}}
        <b>({{formatFileSize(file.content.size)}})</b>
      </div>
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-evenly">
        <mat-form-field subscriptSizing="dynamic" class="uploaded-file-type">
          <mat-select placeholder="{{'ATTACHMENT_TYPE' | translate}}" [(value)]="file.attachmentTypeCode">
            <mat-option [value]="null">
              {{'NOT_SELECTED' | translate}}
            </mat-option>
            <mat-option *ngFor="let fileType of attachmentTypes" [value]="fileType.code">
              {{fileType.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-icon-button class="error-color" (click)="removeFile(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-divider class="line-divider"></mat-divider>
  </div>

</div>

<div style="width: 100%; display: flex; justify-content: flex-end" *ngIf="!isErrorInData">
  <button mat-flat-button
          [disabled]="uploadList.files.length === 0 || loading"
          (click)="onSendClick()">
    {{'UPLOAD' | translate}}
  </button>
</div>
